<template>

  <t-dialog-form :generalErrors="generalErrors" :title="title" :ok-text="okText" @show="showModal" @hidden="resetModal"
                 :id="id" :command="command" :status="status" :variant="variant"
                 ref="dialog_form" @onSubmit="onSubmit">

    <b-card-title>Informe qual a origem para copiar os dados</b-card-title>

    <t-input-code-label :status="status" production v-model="form.productionOrderId" />



  </t-dialog-form>

</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";
import ProductionOrderStepService from "@/services/modules/production/ProductionOrderStep.service";


export default {
  name: "StepCopyDataDialog",
  components: {tDialogForm},
  mixins: [pageDialogFormMixin],
  data() {
    return {
      id: "modal-copy-data-other-step",
      title: "Copiar dados",
      okText: "Importar Dados",
      form: {
        productionOrderId: 0,
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      variant: "primary",

    }
  },
  methods: {

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    async showModal() {

      //Limpa os campos
      this.resetModal()

      this.form.productionOrderId = ""

    },

    async onSubmit() {

      this.status = "sending"

      await ProductionOrderStepService.copyData(this.primaryKey,this.form.productionOrderId).then((response) => {

        setTimeout(() => {

          //Fecha e devolve os valores desejado para continuidade
          this.$nextTick(() => {

            this.$bvModal.hide(this.id)
            this.$emit('onSubmit', response.data)

          });

        }, 50)

      }).catch(error => this.responseError(error))

    }
  }
}
</script>
